import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';

import { scrollIntoViewIfNeeded } from 'dpl/shared/utils';

export default class FancyDropdownListItem extends Component {
  static propTypes = {
    isSelected: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
    onMount: PropTypes.func.isRequired,
    onUnmount: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onClick: PropTypes.func,
    children: PropTypes.node.isRequired,
    className: PropTypes.string.isRequired,
    selectedClassName: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    menuRef: PropTypes.object.isRequired
  };

  static defaultProps = {
    onClick: null
  };

  ref = createRef();
  _mouseTriggered = false;

  bindEnterKey() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  unbindEnterKey() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isSelected && this.props.isSelected) {
      this.bindEnterKey();
      // Make sure we don't trigger scroll if element selected changed bc of
      // hover (as opposed to arrow keys). Otherwise scrolling gets out of
      // control.
      if (!this._mouseTriggered && this.props.menuRef.current) {
        scrollIntoViewIfNeeded(this.props.menuRef.current, this.ref.current);
      }
      this._mouseTriggered = false;
    } else if (prevProps.isSelected && !this.props.isSelected) {
      this.unbindEnterKey();
    }
    this.props.onUpdate();
  }

  componentDidMount() {
    this.props.onMount();
  }

  componentWillUnmount() {
    this.props.onUnmount();
    this.unbindEnterKey();
  }

  handleKeyDown = e => {
    if (e.key === 'Enter') {
      e.preventDefault();
      this.ref.current.firstChild.click();
    }
  };

  handleMouseEnter = e => {
    this._mouseTriggered = true;
    this.props.onMouseEnter(e);
  };

  render() {
    return (
      <li
        ref={this.ref}
        className={`
          FancyDropdownListItem
          lh-copy db transition
          ${this.props.className}
          ${this.props.isSelected ? this.props.selectedClassName : ''}
        `}
        onMouseEnter={this.handleMouseEnter}
        onFocus={this.props.onMouseEnter}
        onClick={this.props.onClick}
        role="presentation"
      >
        {this.props.children}
      </li>
    );
  }
}
